<script>
    import {
        token,
        apiUrl,
        cloudant_id,
        corp_name,
        corp_id,
        corp_uname,
        corp_emails,
        region,
        addQuestions,
        addQuestionsAns,
        primaryColor,
        headerColor,
        feverDetected
    } from '../store.js'
    import axios from "axios";
    import Loader from "./Loader.svelte"
    import { navigateTo } from 'svelte-router-spa'
    import { onMount } from 'svelte';

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const tempToken = urlParams.get('token')
    const isFeverDetected = urlParams.get('fever')

    onMount(() => {
        corp_name.set('')
        primaryColor.set('#1600ff')
        headerColor.set('#161616')
        if (tempToken) { token.set(tempToken) } else { token.set('') }
        if (isFeverDetected) { feverDetected.set('true') } else { feverDetected.set('') }
        addQuestions.set(JSON.stringify(''))
        addQuestionsAns.set(JSON.stringify(''))
    })

    let isLoading = false
    let queryCorp = async function() {
        isLoading = true
        let url = `${apiUrl}/query-corp`
        let headers = { 'X-IBM-Client-Id': process.env.CLOUD_KEY }
        let data = { 'uname': $corp_uname }
        try {
            let req = await axios.post(url, data, {headers: headers})
            isLoading = false
            cloudant_id.set(req.data.cloudant_id)
            corp_name.set(req.data.corp_name)
            corp_id.set(req.data.corp_id)
            corp_uname.set($corp_uname)
            region.set(req.data.region)
            primaryColor.set(req.data.colors.primary)
            headerColor.set(req.data.colors.header)
            let emails = req.data.emails
            if (emails && emails.length > 0) {
                corp_emails.set(JSON.stringify(emails))
            } else {
                corp_emails.set(JSON.stringify([]))
            }
            if(req.data.questions) {
                addQuestions.set(JSON.stringify(req.data.questions))
            }
            navigateTo('legal')
        } catch(e) {
            isLoading = false
            alert(e)
        }
    }
</script>

<main class="body">
    {#if isLoading}
    <Loader />
    {/if}

    <div class="content">
        <div>
            <h1>Welcome to SEQu-HEALTH Pro</h1>
            <p>Please enter your company code</p>
            <input type="text" bind:value={$corp_uname}>

            {#if $corp_uname}
            <a class="btn btn-primary" on:click={queryCorp}>Begin Assessment →</a>
            {/if}
        </div>
    </div>
</main>

<style>
    pre {
        white-space: pre-wrap;
        white-space: -moz-pre-wrap;
        white-space: -pre-wrap;
        white-space: -o-pre-wrap;
        word-wrap: break-word;
    }
</style>